function textInfos(state = {

  texts: null,
  footerLinks: [],
  currentText: null,
  infoTitle: '',
  infoText: '',
  selectedRow: null,
  modalIsVisible: false,

}, action) {
  switch (action.type) {
    case 'TEXTINFOS_GET_INFO_TEXTS_SUCCEEDED': {
      return {
        ...state,
        texts: action.texts,
      };
    }

    case 'TEXTINFOS_GET_INFO_TEXT_SUCCEEDED': {
      return {
        ...state,
        currentText: action.info,
      };
    }

    case 'TEXTINFOS_LIST_INFO_TEXTS_SUCCEEDED': {
      return {
        ...state,
        footerLinks: action.texts,
      };
    }

    case 'TEXTINFOS_TOGGLE_MODAL': {
      return {
        ...state,
        infoTitle: '',
        infoText: '',
        modalIsVisible: action.modalIsVisible,
      };
    }

    case 'TEXTINFOS_CHANGE_FIELD': {
      return {
        ...state,
        [action.fieldId]: action.value,
      };
    }

    case 'TEXTINFOS_EDIT_INFOTEXT_ROW': {
      return {
        ...state,
        selectedRow: action.row.id,
        infoTitle: action.row.name,
        infoText: action.row.text,
        modalIsVisible: true,
      };
    }

    case 'TEXTINFOS_CREATE_TEXTINFO_SUCCEEDED': {
      return {
        ...state,
        selectedRow: null,
        infoTitle: '',
        infoText: '',
        modalIsVisible: false,
      };
    }

    default:
      return state;
  }
}


export default textInfos;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/reducers/textInfos.js